import "./chip-group.scss";
import InputWrapper from "../input-wrapper/input-wrapper";

export default function ChipGroup(props) {
  const {
    options = [],
    values = [],
    onChange,
    disabled,
    className = "",
    style,
    ...rest
  } = props;

  return (
    <InputWrapper
      {...rest}
      inputType="checkbox-group"
      className={`chip-group-wrapper ${className}`}
    >
      <fieldset
        className={`input-chip-group ${className} col col-12`}
        style={style}
        disabled={disabled}
      >
        {options.map((option) => {
          const checked = values.includes(option.value);

          return (
            <label
              key={option.value}
              htmlFor={`${props.name}_${option.value}`}
              className={`input-chip choice text lead medium bold ${
                checked ? "selected" : ""
              } ${disabled ? "disabled" : ""}`}
            >
              <input
                id={`${props.name}_${option.value}`}
                type="checkbox"
                value={option.value}
                checked={checked}
                disabled={disabled}
                onChange={(e) => onChange?.(option.value, e.target.checked)}
              />

              <span className="group">
                {option.icon && !option.icons && (
                  <span className="icon-leading">
                    <span
                      className="icon medium"
                      style={{
                        color: "var(--color-theme-variant)",
                        WebkitMaskImage: `url(https://mwa.tui.com/shared/mwa/assets/v2/icons/tui-light/${option.icon}.svg)`,
                        maskImage: `url(https://mwa.tui.com/shared/mwa/assets/v2/icons/tui-light/${option.icon}.svg)`,
                      }}
                    />
                  </span>
                )}

                {option.icons && option.icons.length > 0 && (
                  <span
                    className={`icon-leading ${
                      option.icons.length > 1 ? "multi-icons" : ""
                    }`}
                  >
                    {option.icons.map((ic) => (
                      <span
                        key={ic}
                        className="icon medium"
                        style={{
                          color: "var(--color-theme-variant)",
                          WebkitMaskImage: `url(https://mwa.tui.com/shared/mwa/assets/v2/icons/tui-light/${ic}.svg)`,
                          maskImage: `url(https://mwa.tui.com/shared/mwa/assets/v2/icons/tui-light/${ic}.svg)`,
                        }}
                      />
                    ))}
                  </span>
                )}

                <span className="label-inline">{option.label}</span>
              </span>
            </label>
          );
        })}
      </fieldset>
    </InputWrapper>
  );
}
